import React from "react";
import { cn } from "../../lib/utils";

/**
 * Reusable skeleton block with gradient shimmer (see styles/global.css).
 */
export function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn(
        "rounded-md skeleton-shimmer bg-[var(--skeleton-base)]",
        className,
      )}
      {...props}
    />
  );
}

export default Skeleton;
